import React, { useState } from 'react';
import { StepContainer, NavigationButtons, InfoBox, RadioGroup } from '../index';
import { useWizard } from '../../wizard';

const DriverConsentNotifyStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [error, setError] = useState<string | null>(null);

  const value = selfServiceData.dlNotifySecondGuardian;
  const radioValue = value === true ? 'yes' : value === false ? 'no' : '';

  const handleChange = (nextValue: string) => {
    if (nextValue === 'yes') {
      updateSelfServiceData('dlNotifySecondGuardian', true);
      setError(null);
    } else if (nextValue === 'no') {
      updateSelfServiceData('dlNotifySecondGuardian', false);
      updateSelfServiceData('dlGuardian2Name', '');
      updateSelfServiceData('dlGuardian2Email', '');
      updateSelfServiceData('dlGuardian2Signed', false);
      setError(null);
    }
  };

  const handleNext = () => {
    if (radioValue === '') {
      setError('Vælg om vi skal informere forælder 2 via mail/Digital Post.');
      return;
    }
    goNext();
  };

  return (
    <StepContainer title="Digital besked til forælder 2">
      <InfoBox type="info">
        <p>Du kan vælge at sende en mock-mail/Digital Post til forælder/værge 2. Hvis du siger ja, spørger vi på næste trin efter kontaktoplysninger.</p>
      </InfoBox>
      <RadioGroup
        name="dlNotifySecondGuardian"
        legend="Skal vi sende mail/Digital Post til forælder/værge 2?"
        value={radioValue}
        onChange={handleChange}
        options={[
          { value: 'yes', label: 'Ja, send mock-mail/Digital Post til forælder/værge 2' },
          { value: 'no', label: 'Nej, jeg håndterer det selv' }
        ]}
        required
      />
      {error && <span className="error-message" role="alert">{error}</span>}
      <NavigationButtons onBack={goBack} onNext={handleNext} />
    </StepContainer>
  );
};

export default DriverConsentNotifyStep;
